import Dialog from '@material-ui/core/Dialog'
import PropTypes from 'prop-types'
import React from 'react'

const SimpleDialog = ({ open, children }) => (
  <Dialog aria-labelledby="simple-dialog-title" open={open}>
    {children}
  </Dialog>
)

SimpleDialog.defaultProps = {
  children: <p />,
  open: false
}

SimpleDialog.propTypes = {
  children: PropTypes.node.isRequired,
  open: PropTypes.bool.isRequired
}

export default SimpleDialog
